import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { siQuoteUrls } from '../../../environments/environment';
import { BaseHttpService } from "./base-http.service";
import { IsSyncNeededRequest, IsSyncNeededResponse, SyncDataRequest, SyncDataResponse } from "../../models/dtos";
import { withSilentBackgroundRequest } from "../../core/errors/http-context-tokens";
import { HttpContext } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class SynchronizationApiService {

  constructor(private readonly baseHttp: BaseHttpService) { }

  isSyncNeeded(requestBody: IsSyncNeededRequest): Observable<IsSyncNeededResponse> {
     const context: HttpContext = withSilentBackgroundRequest();
    return this.baseHttp.post<IsSyncNeededResponse>(`${siQuoteUrls.synchronization}/IsSyncNeeded`, requestBody, { context });
  }

  getSyncData(requestBody: SyncDataRequest): Observable<SyncDataResponse> {
    return this.baseHttp.post<SyncDataResponse>(`${siQuoteUrls.synchronization}/GetSyncData`, requestBody);
  }
}